export default __webpack_public_path__ + "static/media/NIAS0360.34I-34816_-19518_0.79a8bae3.jpg";